export const AGENT_SESSIONS_ONBOARDING_STATE_KEYS = {
	HAS_OPENED_AGENT_SESSION_FOR_YOU: 'agent-sessions:hasOpenedAgentSessionForYou',
	HAS_OPENED_AGENT_SESSION_RECENT: 'agent-sessions:hasOpenedAgentSessionRecent',
} as const;

export const AgentSessionsOnboardingKeys: readonly (
	| 'agent-sessions:hasOpenedAgentSessionForYou'
	| 'agent-sessions:hasOpenedAgentSessionRecent'
)[] = Object.values(AGENT_SESSIONS_ONBOARDING_STATE_KEYS);
